import React, { useState } from 'react';

function CreateAgenturDialog({ open, onClose, onCreate, loading = false, error = '' }) {
  const [name, setName] = useState('');
  const [beschreibung, setBeschreibung] = useState('');

  const handleSave = () => {
    if (!name.trim()) {
      return;
    }
    onCreate({ name: name.trim(), beschreibung: beschreibung.trim() });
    setName('');
    setBeschreibung('');
  };

  const handleClose = () => {
    setName('');
    setBeschreibung('');
    onClose();
  };

  if (!open) return null;

  return (
    <div className="modal-backdrop">
      <div className="modal">
        <h2>Neue Agentur anlegen</h2>
        <div className="form-group">
          <label>Agenturname *</label>
          <input
            type="text"
            value={name}
            onChange={e => setName(e.target.value)}
            placeholder="Name der Agentur"
            required
            disabled={loading}
          />
        </div>
        <div className="form-group">
          <label>Beschreibung</label>
          <textarea
            value={beschreibung}
            onChange={e => setBeschreibung(e.target.value)}
            placeholder="Beschreibung (optional)"
            rows={3}
            disabled={loading}
          />
        </div>
        {error && <div className="error-message">{error}</div>}
        <div className="modal-actions">
          <button className="cancel-btn" onClick={handleClose} disabled={loading}>Abbrechen</button>
          <button className="save-btn" onClick={handleSave} disabled={loading || !name.trim()}>Speichern</button>
        </div>
      </div>
      <style jsx>{`
        .modal-backdrop {
          position: fixed;
          top: 0; left: 0; right: 0; bottom: 0;
          background: rgba(0,0,0,0.3);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
        }
        .modal {
          background: #fff;
          border-radius: 8px;
          padding: 2rem;
          min-width: 320px;
          max-width: 95vw;
          box-shadow: 0 4px 24px rgba(0,0,0,0.15);
        }
        .form-group {
          margin-bottom: 1.2rem;
        }
        .form-group label {
          display: block;
          margin-bottom: 0.3rem;
          font-weight: 500;
        }
        .form-group input,
        .form-group textarea {
          width: 100%;
          padding: 8px 10px;
          border: 1px solid #cbd5e0;
          border-radius: 5px;
          font-size: 1rem;
        }
        .error-message {
          color: #c53030;
          background: #fed7d7;
          padding: 0.5rem 1rem;
          border-radius: 5px;
          margin-bottom: 1rem;
        }
        .modal-actions {
          display: flex;
          justify-content: flex-end;
          gap: 1rem;
        }
        .cancel-btn, .save-btn {
          padding: 8px 18px;
          border: none;
          border-radius: 5px;
          font-size: 1rem;
          cursor: pointer;
        }
        .cancel-btn {
          background: #e2e8f0;
        }
        .save-btn {
          background: #3182ce;
          color: #fff;
        }
        .save-btn:hover {
          background: #2563eb;
        }
      `}</style>
    </div>
  );
}

export default CreateAgenturDialog; 